import { isEmpty } from 'lodash';
import { serviceDirectoryApiClient } from '@/services/service-directory';

export interface AppFeatures {
  featureId: string;
  description: string;
}

export interface AppInfoForm {
  name: string;
  description: string;
  appFeatures: string;
  published: boolean;
  sequence: number;
  appImageList: File[];
  imageUrl: string[];
  appStoreLink: string;
  playStoreLink: string;
  iOSBetaLink: string;
  AndroidBetaLink: string;
  demoVideo: string;
  appStoreRating: number;
  playStoreRating: number;
}

class AppInfo {
  fetchAppsInfo = async (organisationId: string) => {
    const response = await serviceDirectoryApiClient.get('apps', {
      headers: {
        'Content-Type': 'multipart/form-data',
        organisationId,
      },
    });

    return response.data;
  };

  createAppInfo = async (appInfo: AppInfoForm, organisationId: string) => {
    const formData = this.formDataAppInfo(appInfo);

    const response = await serviceDirectoryApiClient.post('apps', formData, {
      headers: { 'Content-Type': 'multipart/form-data', organisationId },
    });

    return response.data;
  };

  updateAppInfo = async (id: string, appInfo: AppInfoForm, organisationId: string) => {
    const formData = this.formDataAppInfo(appInfo);
    const response = await serviceDirectoryApiClient.put(`apps/${id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data', organisationId },
    });
    return response.data;
  };

  deleteAppInfo = async (id: string, organisationId: string) => {
    const response = await serviceDirectoryApiClient.delete(`apps/${id}`, {
      headers: { organisationId },
    });
    return response.data;
  };

  scrapeAppInfo = async (id: string, appStoreLink?: string, playStoreLink?: string) => {
    const response = await serviceDirectoryApiClient.post(`apps/${id}/scrape`, {
      appStoreLink,
      playStoreLink,
    });
    return response.data;
  };

  createAndScrapeAppInfo = async (organisationId: string, urlScrape: string) => {
    const response = await serviceDirectoryApiClient.post(
      `apps/scrape`,
      {
        urlScrape,
      },
      {
        headers: {
          organisationId,
        },
      }
    );
    return response.data;
  };

  private formDataAppInfo = (appInfo: AppInfoForm) => {
    const formData = new FormData();
    formData.append('name', appInfo.name);
    if (!isEmpty(appInfo.appImageList)) {
      appInfo.appImageList.forEach((image) => {
        image && formData.append('appImageList', image);
      });
    }
    formData.append('appFeatures', appInfo.appFeatures ?? '');
    formData.append('description', appInfo.description ?? '');
    formData.append('sequence', appInfo.sequence.toString());
    formData.append('published', appInfo.published.toString());
    formData.append('appStoreLink', appInfo.appStoreLink ?? '');
    formData.append('playStoreLink', appInfo.playStoreLink ?? '');
    formData.append('iOSBetaLink', appInfo.iOSBetaLink ?? '');
    formData.append('AndroidBetaLink', appInfo.AndroidBetaLink ?? '');
    formData.append('demoVideo', appInfo.demoVideo ?? '');
    appInfo.appStoreRating && formData.append('appStoreRating', appInfo.appStoreRating.toString());
    appInfo.playStoreRating && formData.append('playStoreRating', appInfo.playStoreRating.toString());
    appInfo.imageUrl && formData.append('imageUrl', JSON.stringify(appInfo.imageUrl));
    return formData;
  };
}

export const AppInfoInstance = new AppInfo();
